import * as fromDatatype from "../datatype-library/index";

export interface bl_del_job_dochdr_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  guid_doc_hdr: fromDatatype.GuidDataFieldInterface;
  guid_region_hdr: fromDatatype.GuidDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  recipient_name: fromDatatype.VarcharDatatypeInterface;
  recipient_contact: fromDatatype.VarcharDatatypeInterface;
  recipient_email: fromDatatype.VarcharDatatypeInterface;
  recipient_id: fromDatatype.VarcharDatatypeInterface;
  currency: fromDatatype.VarcharDatatypeInterface;
  delivery_status: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  delivery_logic: fromDatatype.VarcharDatatypeInterface;
  process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  process_status_guid: fromDatatype.GuidDataFieldInterface;
  process_status_name: fromDatatype.VarcharDatatypeInterface;
  process_resolution_guid: fromDatatype.GuidDataFieldInterface;
  process_resolution_code: fromDatatype.VarcharDatatypeInterface;
  pkg_no_of_parts: fromDatatype.NumericDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_4: fromDatatype.VarcharDatatypeInterface;
  client_doc_5: fromDatatype.VarcharDatatypeInterface;
  proof_rct_name: fromDatatype.VarcharDatatypeInterface;
  proof_rct_id: fromDatatype.VarcharDatatypeInterface;
  proof_rct_phone: fromDatatype.VarcharDatatypeInterface;
  proof_rct_remarks: fromDatatype.VarcharDatatypeInterface;
  collection_amount: fromDatatype.NumericDatatypeInterface;
  reason: fromDatatype.VarcharDatatypeInterface;
}

export class bl_del_job_dochdr_link_RowClass
  implements bl_del_job_dochdr_link_RowInterface
{
  pkg_no_of_parts: fromDatatype.NumericDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_4: fromDatatype.VarcharDatatypeInterface;
  client_doc_5: fromDatatype.VarcharDatatypeInterface;
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  guid_doc_hdr: fromDatatype.GuidDataFieldInterface;
  guid_region_hdr: fromDatatype.GuidDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  recipient_name: fromDatatype.VarcharDatatypeInterface;
  recipient_contact: fromDatatype.VarcharDatatypeInterface;
  recipient_email: fromDatatype.VarcharDatatypeInterface;
  recipient_id: fromDatatype.VarcharDatatypeInterface;
  currency: fromDatatype.VarcharDatatypeInterface;
  delivery_status: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  delivery_logic: fromDatatype.VarcharDatatypeInterface;
  process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  process_status_guid: fromDatatype.GuidDataFieldInterface;
  process_status_name: fromDatatype.VarcharDatatypeInterface;
  process_resolution_guid: fromDatatype.GuidDataFieldInterface;
  process_resolution_code: fromDatatype.VarcharDatatypeInterface;
  proof_rct_name: fromDatatype.VarcharDatatypeInterface;
  proof_rct_id: fromDatatype.VarcharDatatypeInterface;
  proof_rct_phone: fromDatatype.VarcharDatatypeInterface;
  proof_rct_remarks: fromDatatype.VarcharDatatypeInterface;
  collection_amount: fromDatatype.NumericDatatypeInterface;
  reason: fromDatatype.VarcharDatatypeInterface;
}
